/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button, FormControlLabel, Grid, Radio, Typography } from '@mui/material';
import { Formik, FormikHelpers, validateYupSchema, yupToFormErrors } from 'formik';
import React, { useEffect, useState } from 'react';
import { DataTable } from '../DataTable';
import { ProceedSaveLater, SubHeading } from './components';
import { MFTextField } from '../../lib/formik';
import UseRadioGroup from '../../lib/formik/Radio';
import MFSelectField from '../../lib/formik/SelectField';
import AddIcon from '@mui/icons-material/Add';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  APMIFlow,
  CompanyMasters,
  CompanyNameMasters,
  SHOW_SECTION_FILLED_BY_INVESTOR_CHECKBOX,
  USER_ROLES,
  YesNoMaster,
} from '../../utils/constant';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { ConfirmationDialog } from '../commonComponents';
import { disclosureOfExcludedSchema } from '../../utils/schema';
import { useDispatch, useSelector } from 'react-redux';
import { showError } from '../../redux-store/actions/auth';
import { useHistory, useParams } from 'react-router';
import {
  ApplicationProps,
  ExcludedCompanyType,
  InvestorEditRouteLinkObj,
} from '../../redux-store/types/api-types';
import { RootStateType } from '../../redux-store/reducers';
import { useSnackbar } from 'notistack';
import {
  applicationComparison,
  applyRoleBasedStatus,
  checkInitialApplicationStatusIsChecker,
  checkIfApplicationIsNonIndividual,
  fieldValidateForInvestor,
  getDisableStatusForjointHolder,
  getInvestorRouteLinks,
  saveForLater,
  saveForLaterInvestorPhotoCapture,
} from '../../utils/utilityFunctions';
import { getCompanies, updateApplication } from '../../redux-store/actions/application';
import MFCheckbox from '../../lib/formik/Checkbox';
import { sectionFilledByInvestor } from '../../utils/declaration';
import { companyType, mdmsCompaniesList } from '../../redux-store/types/mdms';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { InvestorEditErrorObj } from '../../redux-store/reducers/investorEditSections';

type updatedCompanyType = ExcludedCompanyType & {
  sno?: number;
};

type Values = {
  isDisclosureOfExclusionsToBeFilledByInvestor: boolean;
  excludedCompaniesCheck: string;
  excludedcompanies: updatedCompanyType[];
  saveType: string;
};

const initialValues: Values = {
  isDisclosureOfExclusionsToBeFilledByInvestor: APMIFlow ? true : false,
  excludedCompaniesCheck: '',
  excludedcompanies: [],
  saveType: 'save and proceed',
};

const newExcludedCompany: updatedCompanyType = {
  isActive: true,
  companySectorType: '',
  companySectorName: '',
  sno: 0,
};

function DisclosureOfExcludedTable({
  values,
  setDialogBox,
  setValues,
  mdmsCompanyList,
}: {
  values: Values;
  setDialogBox: any;
  setValues: any;
  mdmsCompanyList: mdmsCompaniesList[];
}): JSX.Element {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);

  const headers = [
    {
      header: 'No.',
      label: 'no',
      renderEditDeleteCell: (row: updatedCompanyType, index: number): JSX.Element => {
        return (
          <>
            <Typography component="h3" sx={{ fontSize: 14, fontWeight: 500 }}>{`${
              index + 1
            }`}</Typography>
          </>
        );
      },
    },
    {
      header: 'Select Type',
      renderEditDeleteCell: (row: updatedCompanyType, index: number): JSX.Element => {
        return (
          <MFSelectField
            name={`excludedcompanies.${row.sno}.companySectorType`}
            items={CompanyMasters.map((type) => ({ key: type, value: type }))}
            applyLabelStyles={true}
            onChange={(e) => {
              const excludedcompanies = values.excludedcompanies;
              setValues({
                ...values,
                excludedcompanies: excludedcompanies.map((company) => {
                  if (company.sno === row.sno)
                    return {
                      ...company,
                      companySectorType: e.target.value,
                      companySectorName: '',
                    };
                  return company;
                }),
              });
            }}
            disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
          />
        );
      },
    },
    {
      header: 'Name of Company/ Sector/ Industry',
      renderEditDeleteCell: (row: updatedCompanyType, index: number): JSX.Element => {
        return row?.companySectorType === 'Company' ? (
          // <MFSelectField
          //   name={`excludedcompanies.${row.sno}.companySectorName`}
          //   items={CompanyNameMasters}
          //   applyLabelStyles={true}
          //   disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
          // />
          <SearchableSelect
            name={`excludedcompanies.${row.sno}.companySectorName`}
            items={mdmsCompanyList.map((list) => ({
              key: list.companyName,
              value: list.symbol,
            }))}
            disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
            searchFieldPlaceholder={'Search Companies'}
            MenuProps={{
              sx: {
                '.MuiPaper-root ': {
                  maxWidth: { xs: '86%', sm: '22%', md: '18%' },
                  maxHeight: '20%',
                  overflowX: 'auto',
                },
                '@media only screen and (min-width: 401px) and (max-width: 600px)': {
                  '.MuiPaper-root': {
                    maxWidth: '40%',
                  },
                },
              },
              disableAutoFocusItem: true,
              MenuListProps: {
                disableListWrap: true,
              },
            }}
          />
        ) : (
          <MFTextField
            name={`excludedcompanies.${row.sno}.companySectorName`}
            placeholder=""
            disabled={getDisableStatusForjointHolder(role, referenceDetail.applicant_type)}
          />
        );
      },
    },
    {
      header: '',
      renderEditDeleteCell: (row: updatedCompanyType, index: number): JSX.Element => {
        return (
          <>
            <DeleteOutlineIcon
              sx={{ cursor: 'pointer' }}
              color={
                values.excludedcompanies?.filter((company) => company.isActive).length > 1 ||
                !getDisableStatusForjointHolder(role, referenceDetail.applicant_type)
                  ? 'primary'
                  : 'disabled'
              }
              onClick={() => {
                if (
                  values.excludedcompanies?.filter((company) => company.isActive).length > 1 ||
                  !getDisableStatusForjointHolder(role, referenceDetail.applicant_type)
                ) {
                  setDialogBox({ Index: row.sno });
                }
              }}
            />
          </>
        );
      },
    },
  ];
  return (
    <DataTable
      tableData={values.excludedcompanies?.filter((data) => data.isActive)}
      tableHeader={headers}
      renderAdditionalRow={false}
      tableHeaderCustomStyles={{
        '.MuiTableCell-head': {
          fontFamily: 'Poppins, sans-serif',
          fontSize: 14,
          fontWeight: 500,
          color: 'primary.main',
          textAlign: 'left',
          backgroundColor: '#F3F8FB',
          // pl: 6,
          '&:nth-of-type(1)': {
            width: 70,
          },
          '&:nth-of-type(2)': {
            pl: 2,
            width: 250,
          },
        },
      }}
      rowCustomStyles={{
        '.MuiTableCell-root': {
          overflowWrap: 'anywhere',
          textAlign: 'left',
          verticalAlign: 'top',
          py: 2,
          '& .MuiFormControl-root, & .MuiOutlinedInput-root': {
            m: 0,
          },
        },
      }}
      boxStyles={{ minHeight: '0', minWidth: 450 }}
    />
  );
}

export default function DisclosureOfExcluded(): JSX.Element {
  const [disclosureData, setDisclosureData] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [dialogbox, setDialogBox] = useState<{
    Index?: number;
  } | null>(null);
  const history = useHistory();
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);
  const { enqueueSnackbar } = useSnackbar();
  const { esignReferenceId } = referenceDetail;
  const [openPopup, setOpenPopup] = useState<{ disclosureOfExclusionsCheck: boolean } | null>(null);
  const { investorEditObj } = useSelector((store: RootStateType) => store.investorEditObj);
  const [investorRouteObj, setInvestorRouteObj] = useState<InvestorEditRouteLinkObj | null>(null);
  const [openPreviewConfirmationPopup, setOpenPreviewConfirmationPopup] = useState(false);
  const [mdmsCompanyList, setMdmsCompanyList] = useState<mdmsCompaniesList[]>([]);
  useEffect(() => {
    (async function () {
      try {
        const companyList = (await dispatch(getCompanies())) as unknown as companyType;

        setMdmsCompanyList(companyList.companies);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);
  useEffect(() => {
    setDisclosureData({
      ...disclosureData,
      isDisclosureOfExclusionsToBeFilledByInvestor:
        application?.isDisclosureOfExclusionsToBeFilledByInvestor ||
        initialValues.isDisclosureOfExclusionsToBeFilledByInvestor,
      excludedCompaniesCheck: application?.excludedCompaniesCheck || '',
      excludedcompanies: application?.excludedcompanies.length
        ? application.excludedcompanies?.map((excludedCompanies, index) => {
            return { ...excludedCompanies, sno: index };
          })
        : [],
    });
  }, [application]);

  useEffect(() => {
    const routeLinkObj =
      (investorEditObj && investorEditObj?.length > 0) ||
      (APMIFlow && referenceDetail?.applicant_type === '1')
        ? getInvestorRouteLinks(
            investorEditObj as InvestorEditErrorObj[],
            history?.location?.pathname?.split('/')?.pop() || '',
            referenceDetail
          )
        : null;
    setInvestorRouteObj(routeLinkObj);
  }, [investorEditObj, referenceDetail]);

  const { referenceId: referenceIdForInvestorPhotoCapture } = useParams<{ referenceId: string }>();

  const handleSubmit = async (values: Values) => {
    try {
      const {
        id,
        applicant1ReferenceId = '',
        currentStep,
        status,
        hasPOA,
        applicationNumber,
      } = application || {};
      const { excludedcompanies, saveType, ...rest } = values;
      const isSaveLater = saveType !== 'save and proceed';

      const updatedPayload = {
        ...application,
        ...rest,
        excludedcompanies:
          YesNoMaster[rest.excludedCompaniesCheck] === YesNoMaster.yes
            ? excludedcompanies
                ?.filter((company) => company?.id || company.isActive)
                ?.map((companiesData) => {
                  const { sno, ...rest } = companiesData;
                  return rest;
                })
            : (excludedcompanies
                ?.map((excludedCompany) => {
                  if (excludedCompany.id) {
                    const { sno, ...rest } = excludedCompany;
                    return { ...rest, isActive: false };
                  }
                  return;
                })
                ?.filter((ele) => ele) as ExcludedCompanyType[]),
      };
      const checkApplication = applicationComparison(
        {
          ...application,
          excludedcompanies: application?.excludedcompanies?.sort(
            (company1, company2) => Number(company1.id) - Number(company2.id)
          ),
        },
        {
          ...updatedPayload,
          excludedcompanies: updatedPayload?.excludedcompanies?.sort(
            (company1, company2) => Number(company1.id) - Number(company2.id)
          ),
          currentStep: !!currentStep && currentStep > 10 ? currentStep : Number(currentStep) + 1,
        }
      );

      //save for later route for investor at liveliness
      const investorEditSaveelaterRoute =
        referenceIdForInvestorPhotoCapture &&
        saveForLaterInvestorPhotoCapture(referenceIdForInvestorPhotoCapture, application);
      const referenceIdForSaveProceedRoute = referenceIdForInvestorPhotoCapture
        ? referenceIdForInvestorPhotoCapture
        : esignReferenceId;

      if (id && !checkApplication) {
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              ...updatedPayload,
              status:
                !hasPOA &&
                checkInitialApplicationStatusIsChecker(application) &&
                status !== 'draft' &&
                applyRoleBasedStatus(role)
                  ? 'sent_to_amc_approver'
                  : status,
              currentStep: investorRouteObj ? currentStep : 11,
              ...(APMIFlow && {
                editedByPrimaryApplicant: investorRouteObj
                  ? true
                  : application?.editedByPrimaryApplicant,
              }),
            },
            applicationId: id,
            ...(isSaveLater && { toastMessage: '' }),
          })
        );
        setLoading(false);
        !isSaveLater
          ? investorRouteObj
            ? investorRouteObj.saveAndProceedSectionLink
              ? history.push(investorRouteObj.saveAndProceedSectionLink, {
                  id,
                  applicant1ReferenceId: referenceIdForSaveProceedRoute,
                })
              : APMIFlow && referenceDetail?.applicant_type === '1'
              ? history.push(`/investment-details/${esignReferenceId}/application-details`)
              : setOpenPreviewConfirmationPopup(true)
            : history.push('related-party-consent', {
                id,
                applicant1ReferenceId: referenceIdForSaveProceedRoute,
              })
          : referenceIdForInvestorPhotoCapture
          ? history.push(
              investorEditSaveelaterRoute.routePath,
              investorEditSaveelaterRoute.routeState
            )
          : investorRouteObj
          ? investorRouteObj.backSectionLink
            ? history.push(investorRouteObj.backSectionLink, {
                id,
                applicant1ReferenceId: referenceIdForSaveProceedRoute,
              })
            : history.push(
                `/investment-details/${referenceDetail.esignReferenceId}/application-details`
              )
          : history.push(saveForLater(role, id, esignReferenceId));
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        !isSaveLater
          ? investorRouteObj
            ? investorRouteObj.saveAndProceedSectionLink
              ? history.push(investorRouteObj.saveAndProceedSectionLink, {
                  id,
                  applicant1ReferenceId: referenceIdForSaveProceedRoute,
                })
              : APMIFlow && referenceDetail?.applicant_type === '1'
              ? history.push(`/investment-details/${esignReferenceId}/application-details`)
              : setOpenPreviewConfirmationPopup(true)
            : history.push('related-party-consent', {
                id,
                applicant1ReferenceId: referenceIdForSaveProceedRoute,
              })
          : referenceIdForInvestorPhotoCapture
          ? history.push(
              investorEditSaveelaterRoute.routePath,
              investorEditSaveelaterRoute.routeState
            )
          : investorRouteObj
          ? investorRouteObj.backSectionLink
            ? history.push(investorRouteObj.backSectionLink, {
                id,
                applicant1ReferenceId: referenceIdForSaveProceedRoute,
              })
            : history.push(
                `/investment-details/${referenceDetail.esignReferenceId}/application-details`
              )
          : history.push(saveForLater(role, id, esignReferenceId));
      }
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
  };

  return (
    <>
      <Formik
        initialValues={disclosureData}
        onSubmit={handleSubmit}
        enableReinitialize={true}
        validate={(values: Values) => {
          try {
            validateYupSchema(
              values,
              disclosureOfExcludedSchema(
                referenceDetail.applicant_type,
                mdmsCompanyList,
                checkIfApplicationIsNonIndividual(application as ApplicationProps)
              ),
              true,
              values
            );
          } catch (e) {
            return yupToFormErrors(e);
          }
        }}>
        {({ handleSubmit, values, setValues, errors }) => (
          <>
            <Grid
              container
              rowSpacing={1}
              //columnSpacing={5}
              sx={{
                width: '100%',
                ml: 0,
                '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
              }}
              component="form"
              noValidate
              onSubmit={handleSubmit}>
              {SHOW_SECTION_FILLED_BY_INVESTOR_CHECKBOX &&
                !fieldValidateForInvestor(referenceDetail.applicant_type, 1, false) &&
                application &&
                !checkIfApplicationIsNonIndividual(application) && (
                  <Grid xs={12} sx={{ mb: 2 }}>
                    <MFCheckbox
                      name="isDisclosureOfExclusionsToBeFilledByInvestor"
                      label={sectionFilledByInvestor}
                      sx={{ display: 'flex' }}
                      onChange={({ target: { checked } }) => {
                        !checked &&
                          setValues({
                            ...values,
                            isDisclosureOfExclusionsToBeFilledByInvestor: checked,
                          });
                        checked && setOpenPopup({ disclosureOfExclusionsCheck: checked });
                      }}
                      checked={values.isDisclosureOfExclusionsToBeFilledByInvestor}
                      disabled={APMIFlow ? true : false}
                    />
                  </Grid>
                )}
              <SubHeading
                sx={{
                  color: '#131836',
                  fontSize: 18,
                  fontWeight: 500,
                  mt: 0,
                  mb: 5,
                }}>{`Excluded Companies`}</SubHeading>
              <Grid xs={12} sm={12} lg={12}>
                <UseRadioGroup
                  formLabel={`Do you want to exclude any specific companies/ sectors / industries from your investment portfolio? ${
                    checkIfApplicationIsNonIndividual(application as ApplicationProps)
                      ? '*'
                      : values.isDisclosureOfExclusionsToBeFilledByInvestor &&
                        !fieldValidateForInvestor(referenceDetail.applicant_type, 1, false)
                      ? ''
                      : '*'
                  }`}
                  name="excludedCompaniesCheck"
                  items={Object.keys(YesNoMaster).map((fundType) => ({
                    label: YesNoMaster[fundType],
                    value: fundType,
                  }))}
                  disabled={
                    getDisableStatusForjointHolder(role, referenceDetail.applicant_type) ||
                    (APMIFlow
                      ? false
                      : values.isDisclosureOfExclusionsToBeFilledByInvestor &&
                        !fieldValidateForInvestor(referenceDetail.applicant_type, 1, false))
                  }
                  onChange={(e) => {
                    setValues({
                      ...values,
                      excludedCompaniesCheck: e.target.value,
                      excludedcompanies:
                        values.excludedcompanies?.filter((data) => data.isActive).length === 0 &&
                        YesNoMaster[e.target.value] === YesNoMaster.yes
                          ? [
                              ...values.excludedcompanies,
                              { ...newExcludedCompany, sno: values.excludedcompanies?.length },
                            ]
                          : values.excludedcompanies,
                    });
                  }}
                />
              </Grid>
              {YesNoMaster[values.excludedCompaniesCheck] === YesNoMaster.yes && (
                <Grid xs={12} sm={12} lg={12}>
                  <Typography component="p" sx={{ fontWeight: 500, fontSize: 16, my: 3 }}>
                    I do not wish to invest in the following bodies corporate/sectors:
                  </Typography>
                  <DisclosureOfExcludedTable
                    values={values}
                    setDialogBox={setDialogBox}
                    setValues={(e: Values) => setValues(e)}
                    mdmsCompanyList={mdmsCompanyList}
                  />
                  <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      variant="outlined"
                      startIcon={<AddIcon />}
                      sx={{
                        color: 'primary.main',
                        fontWeight: 500,
                        fontSize: 14,
                        mt: 2,
                        px: 4,
                      }}
                      onClick={() => {
                        setValues({
                          ...values,
                          excludedcompanies: [
                            ...values.excludedcompanies,
                            { ...newExcludedCompany, sno: values.excludedcompanies?.length },
                          ],
                        });
                      }}
                      disabled={
                        // getDisableStatusForjointHolder(role,referenceDetail.applicant_type)
                        getDisableStatusForjointHolder(role, referenceDetail.applicant_type)
                      }>
                      Add Company
                    </Button>
                  </Grid>
                </Grid>
              )}
              <ConfirmationDialog
                message={`Are you sure you want to delete the company ?`}
                open={dialogbox !== null}
                setOpen={() => setDialogBox(null)}
                onSave={() => {
                  setValues({
                    ...values,
                    excludedcompanies: values.excludedcompanies?.map((data, ind) => {
                      if (data.sno === dialogbox?.Index) {
                        return { ...data, isActive: false };
                      }
                      return data;
                    }),
                  });
                  setDialogBox(null);
                }}
                onCancel={() => setDialogBox(null)}
              />
              <ProceedSaveLater
                saveLater={() => {
                  setValues({
                    ...values,
                    saveType: 'save for later',
                  });
                }}
                saveAndProceed={() => {
                  setValues({
                    ...values,
                    saveType: 'save and proceed',
                  });
                }}
                loader={loading}
                clickedButton={values.saveType}
                saveForLaterButtonText={
                  investorRouteObj
                    ? investorRouteObj.backSectionLink
                      ? `Save and Back To ${investorRouteObj.backSectionName}`
                      : 'Save For Later'
                    : 'Save For Later'
                }
                saveButtonText={
                  investorRouteObj
                    ? investorRouteObj.saveAndProceedSectionLink
                      ? 'Save and Proceed'
                      : 'Save Application'
                    : 'Save and Proceed'
                }
                showEndIcon={
                  investorRouteObj
                    ? investorRouteObj.saveAndProceedSectionLink
                      ? true
                      : false
                    : true
                }
                showSaveForLater={
                  investorRouteObj ? (investorRouteObj.backSectionLink ? true : false) : true
                }
              />
              <ConfirmationDialog
                message={`Are you sure you do not wish to fill this step ?`}
                open={openPopup !== null}
                setOpen={() => {
                  setOpenPopup(null);
                }}
                onSave={() => {
                  setValues({
                    ...values,
                    isDisclosureOfExclusionsToBeFilledByInvestor:
                      openPopup?.disclosureOfExclusionsCheck as boolean,
                    excludedCompaniesCheck: '',
                    excludedcompanies: values.excludedcompanies?.map((data) => {
                      return { ...data, isActive: false };
                    }),
                  });
                  setOpenPopup(null);
                }}
                onCancel={() => {
                  setOpenPopup(null);
                }}
              />
              <ConfirmationDialog
                message={`Application Saved successfully and no further edits provided, Are you sure you want to go back to preview?`}
                open={openPreviewConfirmationPopup}
                setOpen={() => {
                  setOpenPreviewConfirmationPopup(false);
                }}
                onSave={() => {
                  setOpenPreviewConfirmationPopup(false);
                  history.push(`/investment-details/${esignReferenceId}/application-details`);
                }}
                onCancel={() => {
                  setOpenPreviewConfirmationPopup(false);
                }}
              />
            </Grid>
          </>
        )}
      </Formik>
    </>
  );
}
